import { makeAutoObservable } from 'mobx';
import { Buyer, BuyerFilter } from '../../models/Buyer';
import { BuyerApi } from '../../apis/Buyer';
import { message } from 'antd';

export class BuyerManagementPageModel {
    buyers: Buyer[] = [];
    selectedBuyer: Buyer | null = null;
    loading = false;
    showDetailModal = false;
    showBlacklistModal = false;
    blacklistReason = '';

    filter: BuyerFilter = {
        searchText: '',
        type: -1,
        isVerified: -1,
        sortField: 'registerTime',
        sortOrder: 'desc'
    };

    constructor() {
        makeAutoObservable(this);
    }

    setFilter = (filter: Partial<BuyerFilter>) => {
        this.filter = { ...this.filter, ...filter };
        this.loadBuyers();
    };

    loadBuyers = async () => {
        this.loading = true;
        try {
            const result = await BuyerApi.getBuyerList(this.filter);
            if (result) {
                this.buyers = result;
            }
        } catch (error) {
            message.error('加载买家列表失败');
        } finally {
            this.loading = false;
        }
    };

    setSelectedBuyer = (buyer: Buyer | null) => {
        this.selectedBuyer = buyer;
        this.showDetailModal = !!buyer;
    };

    selectBuyer = (buyer: Buyer) => {
        this.setSelectedBuyer(buyer);
    };

    closeDetailModal = () => {
        this.setSelectedBuyer(null);
    };

    setShowBlacklistModal = (show: boolean) => {
        this.showBlacklistModal = show;
    };

    showBlacklistConfirm = () => {
        this.showBlacklistModal = true;
    };

    closeBlacklistModal = () => {
        this.setShowBlacklistModal(false);
        this.blacklistReason = '';
    };

    setBlacklistReason = (reason: string) => {
        this.blacklistReason = reason;
    };

    updateBlacklistStatus = async (buyerId: string, type: 0 | 1, reason: string) => {
        try {
            const success = await BuyerApi.blacklistBuyer({
                buyerId,
                type,
                reason
            });
            
            if (success) {
                message.success(type === 0 ? '拉黑成功' : '取消拉黑成功');
                await this.loadBuyers();
            } else {
                message.error(type === 0 ? '拉黑失败' : '取消拉黑失败');
            }
        } catch (error) {
            message.error(type === 0 ? '拉黑失败' : '取消拉黑失败');
        }
    };

    resetFilters = async () => {
        this.filter = {
            searchText: '',
            type: -1,
            isVerified: -1,
            sortField: 'registerTime',
            sortOrder: 'desc'
        };
        await this.loadBuyers();
    };
} 